import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AddAffiliatePopup from './AddAffiliatePopup';
import LoaderSpinner from '../common/Loader';
import AlertDialogModal from '../common/AlertDialog';
import { useAffiliateList, useAffiliateActions, useSortAndFilter } from './Hooks/AffiliateManagement.hooks';
import { AffiliatePageHeader, AffiliateTable, AffiliatePaginationSection } from './Subcomponents/AffiliateManagement.subcomponents';

export default function AffiliateManagement() {
    const navigate = useNavigate();
    const [sortColumn, setSortColumn] = useState('');
    const [sortOrder, setSortOrder] = useState('DESCENDING');
    const [showAddAffiliatePopup, setShowAddAffiliatePopup] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedAffiliateForDelete, setSelectedAffiliateForDelete] = useState(null);

    // Use custom hooks for data management and actions
    const affiliateList = useAffiliateList();
    const actions = useAffiliateActions({
        setShowAddAffiliatePopup,
        setCurrentPageIndex: affiliateList.setCurrentPageIndex,
        setRefreshKey: affiliateList.setRefreshKey,
    });

    const sorting = useSortAndFilter(affiliateList.affiliateData, sortColumn, sortOrder, setSortColumn, setSortOrder);

    // Delete modal handlers
    const handleDeleteClick = (inviteId) => {
        setSelectedAffiliateForDelete(inviteId);
        setShowDeleteModal(true);
    };

    const handleCancelDelete = () => {
        setShowDeleteModal(false);
        setSelectedAffiliateForDelete(null);
    };

    const handleConfirmDelete = () => {
        actions.handleDeleteInvitation(selectedAffiliateForDelete);
        setShowDeleteModal(false);
        setSelectedAffiliateForDelete(null);
    };

    return (
        <main>
            <div className="main__container">
                <AffiliatePageHeader
                    onAddClick={() => setShowAddAffiliatePopup(true)}
                    onBackClick={() => navigate('/setting')}
                />

                <div className="main_content cus-page-content-sec incomingTbl">
                    <div className="top_right_button_container cus-content-only-sec">
                        <div className="incomingTbl tableFixHead main_content_table_history">
                            {affiliateList.loading && <LoaderSpinner />}
                            {!affiliateList.loading && (
                                <AffiliateTable
                                    data={sorting.processedData}
                                    sortColumn={sorting.sortColumn}
                                    sortOrder={sorting.sortOrder}
                                    onSort={sorting.handleSortingColumn}
                                    startIdx={0}
                                    onDelete={handleDeleteClick}
                                    onCopy={actions.handleCopyInvitationUrl}
                                />
                            )}
                        </div>
                        <AlertDialogModal
                            modalClass={'modalDeleteWrapper'}
                            modalShow={showDeleteModal}
                            headingText={'Delete Invitation'}
                            messageText={'Are you sure you want to delete this invitation?'}
                            handleCancelDeleteAlert={handleCancelDelete}
                            handleYesDeleteAlert={handleConfirmDelete}
                        />
                    </div>
                </div>

                {!affiliateList.loading && (
                    <AffiliatePaginationSection
                        paginatedData={sorting.processedData}
                        pagination={{
                            numberOfPage: affiliateList.pageSize,
                            currentPage: affiliateList.currentPageIndex,
                            totalPages: Math.ceil(affiliateList.totalRecords / affiliateList.pageSize),
                            setCurrentPage: affiliateList.setCurrentPageIndex,
                            setNumberOfPage: affiliateList.setPageSize,
                        }}
                        affiliateDataLength={affiliateList.totalRecords}
                    />
                )}
            </div>
            <AddAffiliatePopup
                showAddAffiliatePopup={showAddAffiliatePopup}
                setShowAddAffiliatePopup={setShowAddAffiliatePopup}
                onAddAffiliate={actions.handleAddAffiliate}
            />
        </main>
    );
}
